module.exports = __webpack_public_path__ + "static/img/commitment-2_light.fe9238d6.png";